import { render, staticRenderFns } from "./UserSidebar.vue?vue&type=template&id=fb1dbd18&scoped=true&"
import script from "./UserSidebar.vue?vue&type=script&lang=ts&"
export * from "./UserSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./UserSidebar.vue?vue&type=style&index=0&id=fb1dbd18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1dbd18",
  null
  
)

export default component.exports